import { useState } from 'react';

import { Col, Row } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { usePositionListSelector } from 'src/hooks';
import { LinkText, MButton, MCard, MModalV2, MTable, MTypography, CurrencyField } from 'src/lib';
import { Position } from 'src/models';
import { ColorConstant, Spacing } from 'src/styles';

import { SummaryDisclaimer } from './SummaryDisclaimer';

export const NonTradedHoldingsTable = () => {
  const [isTermsAndConditionsVisible, setIsTermsAndConditionsVisible] = useState(false);

  const handleDisclaimer = () => {
    setIsTermsAndConditionsVisible(true);
  };
  const { nonTradablePositionList, isPositionListLoading } = usePositionListSelector();

  const cols: ColumnsType<Position> = [
    {
      title: 'Name',
      dataIndex: 'description',
      render: value => <LinkText value={value} />,
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
    },
    {
      title: 'Purchase Price',
      dataIndex: 'purchasePrice',
      render: (purchasePrice: number) => <CurrencyField value={purchasePrice} />,
    },
    {
      title: 'Value',
      dataIndex: 'value',
      render: (value: number) => <CurrencyField value={value} />,
    },
    {
      title: 'Total Cost',
      dataIndex: 'totalCost',
      render: (totalCost: number) => <CurrencyField value={totalCost} />,
    },
    {
      title: 'Total Value',
      dataIndex: 'totalValue',
      render: (totalValue: number) => <CurrencyField value={totalValue} />,
    },
  ];

  return (
    <Row>
      <Col span={24} id='securities-section'>
        <Row>
          <Col span={24} className={Spacing.my16}>
            <MTypography variant='h4' weight='semibold' color={ColorConstant.BRAND6}>
              Non-Traded Holdings
            </MTypography>
          </Col>
          <Col span={24} className={Spacing.mt16}>
            <MCard>
              <MTable
                columns={cols}
                data={nonTradablePositionList}
                pagination={false}
                loading={isPositionListLoading}
                scroll={{ y: 750 }}
                rowKey={row => row.id}
                testId={'non-traded-holdings-table'}
              />
            </MCard>
          </Col>
          <Col span={24} className={Spacing.mt12}>
            <MTypography variant='h6'>
              Please note: values for non-traded holdings may display a lower value than the price you paid.{' '}
              <a onClick={() => handleDisclaimer()}>Click here</a> for more information regarding the value.
            </MTypography>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <MModalV2
          title='Terms and Conditions'
          open={isTermsAndConditionsVisible}
          onClose={() => setIsTermsAndConditionsVisible(false)}
          body={<SummaryDisclaimer />}
          footer={
            <MButton type='tertiary' onClick={() => setIsTermsAndConditionsVisible(false)}>
              Close
            </MButton>
          }
        />
      </Col>
    </Row>
  );
};
